import { ButtonColor } from "enums/Button";
import Button, { ButtonProps } from "./Button";

// "+ Label": adds a row or a record. The plus is drawn here, once, so no
// label or translation carries its own.
export const AddButton = ({ children, ...props }: ButtonProps) => (
  <Button color={ButtonColor.Primary} {...props}>
    + {children}
  </Button>
);
